import useSWR, { mutate } from 'swr';
import useSWRMutation from 'swr/mutation';
import settings from '/@/core/settings';
import { axFetch } from '/@/store/session/actions';

export const getUserLocationsFromApi = async ({
    level,
    page,
    pageSize,
    parentIdIn,
    parentId,
}: {
    level: number;
    page?: number;
    pageSize?: number;
    parentIdIn?: number[];
    parentId?: number;
}) => {
    const apiUrl = new URL(settings.urls.users.locations, window.location.origin);
    const res = await axFetch.get(apiUrl.toString(), {
        params: { page_size: pageSize, page, level, parent_id__in: parentIdIn?.join(','), parent_id: parentId },
    });
    return res.data;
};

export const useUserLocations = (
    {
        level = 0,
        page,
        pageSize = 10,
        parentIdIn,
        parentId,
    }: {
        level: number;
        page?: number;
        pageSize?: number;
        parentIdIn?: number[];
        parentId?: number;
    },
    { enabled = true }: { enabled?: boolean } = { enabled: true }
) =>
    // Location data doesn't change mid-session; avoid re-fetching on remount or focus.
    useSWR(
        enabled ? { key: 'useUserLocations', page, pageSize, level, parentIdIn, parentId } : null,
        getUserLocationsFromApi,
        { revalidateIfStale: false, revalidateOnFocus: false, revalidateOnReconnect: false }
    );

export const useSetUserLocations = () =>
    useSWRMutation(
        {
            key: 'useSetUserLocations',
        },
        (key, { arg }: { arg: number[] }) => axFetch.post(settings.urls.users.locations, { location_ids: arg }),
        {
            onSuccess: () => {
                mutate((key) => key?.key == 'useUserLocations' || key?.key == 'useUserZones');
            },
        }
    );

export const getUserZonesFromApi = async ({
    page,
    pageSize,
    type,
}: {
    page?: number;
    pageSize?: number;
    type?: 'corn' | 'corn_environment' | 'soy' | 'weeds' | 'gdu' | 'mda' | 'rib';
}) => {
    const apiUrl = new URL(settings.urls.users.zones, window.location.origin);
    const res = await axFetch.get(apiUrl.toString(), {
        params: { page_size: pageSize, page, type },
    });
    return res.data;
};

export const useUserZones = (
    {
        page,
        pageSize = 10,
        type,
    }: {
        page?: number;
        pageSize?: number;
        type?: 'corn' | 'corn_environment' | 'soy' | 'weeds' | 'gdu' | 'mda' | 'rib';
    },
    { enabled = true }: { enabled?: boolean } = { enabled: true }
) => useSWR(enabled ? { key: 'useUserZones', page, pageSize, type } : null, getUserZonesFromApi);
